import { ReactNode } from 'react';
import { FeatureAnnouncementDriftV3Modal } from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncements/FeatureAnnouncementDriftV3Modal';
import { FeatureAnnouncementAutoSigningModal } from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncements/FeatureAnnouncementAutoSigningModal';
import { FeatureAnnouncementPerMarketLeverageModal } from 'src/components/Modals/FeatureAnnouncementModal/FeatureAnnouncements/FeatureAnnouncementPerMarketLeverageModal';
import { FeatureAnnouncementName } from 'src/constants/featureAnnouncements';

export interface FeatureAnnouncementModalProps {
	announcementName: FeatureAnnouncementName;
}

const ANNOUNCEMENT_NAME_TO_MODAL: Record<FeatureAnnouncementName, ReactNode> = {
	privyAutoSigning: <FeatureAnnouncementAutoSigningModal />,
	driftV3: <FeatureAnnouncementDriftV3Modal />,
	perMarketLeverage: <FeatureAnnouncementPerMarketLeverageModal />,
};

export default function FeatureAnnouncementModal({
	announcementName,
}: FeatureAnnouncementModalProps) {
	return ANNOUNCEMENT_NAME_TO_MODAL[announcementName];
}
